export function hasShareUriScheme(uri: string | null | undefined): boolean {
  if (!uri) {
    return false
  }
  return ["tel", "sms", "mailto"].some((scheme) => uri.startsWith(`${scheme}:`))
}
